import { useTranslation } from 'react-i18next';
import type { RivhitSyncState } from '../hooks/useRivhitSyncStatus';

interface Props {
  syncState: RivhitSyncState;
}

export default function RivhitSyncBanner({ syncState }: Props) {
  const { t } = useTranslation();

  if (syncState.syncing) {
    return (
      <div className="flex items-center gap-3 rounded-lg bg-amber-50 border border-amber-300 px-4 py-3 shadow-sm">
        <svg className="h-5 w-5 text-amber-600 animate-spin flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
        </svg>
        <div>
          <span className="text-sm font-semibold text-amber-800">
            {t('sync.inProgressTitle', 'Syncing data from Rivhit…')}
          </span>
          <p className="text-xs text-amber-700 mt-0.5">
            {t('sync.inProgressHint', 'Data may be incomplete. The page will refresh automatically when sync finishes.')}
          </p>
        </div>
      </div>
    );
  }

  if (syncState.error) {
    return (
      <div className="flex items-center gap-3 rounded-lg bg-red-50 border border-red-200 px-4 py-3 shadow-sm">
        <span className="text-red-500 flex-shrink-0">⚠️</span>
        <div>
          <span className="text-sm font-semibold text-red-800">
            {t('sync.errorTitle', 'Sync failed')}
          </span>
          <p className="text-xs text-red-600 mt-0.5">{syncState.error}</p>
        </div>
      </div>
    );
  }

  return null;
}
